import { getApiBaseUrl } from '../utils/apiBaseUrl';

export interface SearchSummaryUser {
  id: number;
  userName: string;
  email: string;
  phoneNumber: string;
  createdDate: string;
}

export interface SearchSummaryItem {
  user: SearchSummaryUser;
  searchedAt: string;
}

export interface SearchSummaryResponse {
  pamCode: string;
  searchCount: number;
  users: SearchSummaryItem[];
}

export const getSearchSummaryUsers = async (
  pamCode: string,
  token: string
): Promise<SearchSummaryResponse> => {

  const baseUrl = getApiBaseUrl();

  const response = await fetch(
    `${baseUrl}/api/Admin/search-summary-users?pamCode=${pamCode}`,
    {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
  );

  if (!response.ok) {
    throw new Error(`Failed to fetch search summary users: ${response.status}`);
  }

  return await response.json();
};